<template>
  <v-card>
    <v-btn @click="play()" fixed  bottom right class="mx-2" elevation="10" fab dark  color="teal darken-2">
      <span v-if="done" class="fab_play">
        {{ $t('detail.done') }}

      </span>
     <span  v-else class="fab_play">
       {{ $t('detail.play') }}
     </span>

   </v-btn>
    <v-card-title background-color="#30AE8F">
      <span v-if="d.name !== undefined && d.name !== null" style="word-break: break-all;"> {{ d.name.fr }}</span>
      <v-skeleton-loader v-else width="250"  type="text" :loading="true" />
      <v-spacer/>
      <v-btn v-if="modal" @click="$store.dispatch('closeDialog',{cleanHash: true})" icon><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-divider/>
    <!--<v-card-actions >

<v-btn :style="{left: '50%', transform:'translateX(-50%)'}"  dark color="teal darken-2">Jouer et gagner {{ d.value }} point(s)</v-btn>

</v-card-actions>-->

    <v-card-text>

<v-list>
      <v-list-item>
        <v-list-item-content >
          <v-list-item-title class="text-capitalize"><v-icon class="mr-3">mdi-text</v-icon>{{ $t("detail.description") }}</v-list-item-title>
          <v-list-item-content v-if="d.description !== undefined">
            {{ d.description.fr}}
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-skeleton-loader  type="text" :loading="true" />
      </v-list-item-content>
        </v-list-item-content>
      </v-list-item>


      <v-list-item v-if="d.location !== undefined">
        <v-list-item-content >
          <v-list-item-title class="text-capitalize"><v-icon class="mr-3">mdi-map-marker</v-icon>{{ $t("detail.location") }}</v-list-item-title>
          <v-list-item-content v-if="d.location !== undefined">
            {{ printLocation() }}
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-skeleton-loader  type="text" :loading="true" />
      </v-list-item-content>
        </v-list-item-content>
      </v-list-item>


      <!--<v-list-item>
        <v-list-item-content >
          <v-list-item-title class="text-capitalize"><v-icon class="mr-3">mdi-pound</v-icon>{{ $t("detail.tags") }}</v-list-item-title>
          <v-list-item-content v-if="d.description !== undefined">
            {{ d.tags.map((t) => { return this.$t('tags.'+t); }).join(', ') }}
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-skeleton-loader  type="text" :loading="true" />
      </v-list-item-content>
        </v-list-item-content>
      </v-list-item>-->

      <v-list-item>
        <v-list-item-content >
          <v-list-item-title class="text-capitalize"><v-icon class="mr-3">mdi-contacts</v-icon>{{ $t("detail.contact") }}</v-list-item-title>
          <v-list-item-content v-if="d.contact !== undefined">
            <v-btn small tile text dark color="teal darken-2" @click="sheetContact = true;">Voir les contacts</v-btn>

        </v-list-item-content>
        <v-list-item-content v-else>
          <v-skeleton-loader  type="text" :loading="true" />
      </v-list-item-content>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content >
          <v-list-item-title class="text-capitalize"><v-icon class="mr-3">mdi-alarm</v-icon>{{ $t("detail.openings") }}</v-list-item-title>
          <p>Compte tenu du contexte actuel nous vous invitons à contacter ce site touristique afin de vérifier ses horaires d'ouvertures.</p>
          <v-list-item-content v-if="d.contact !== undefined">
            <v-btn small tile text dark color="teal darken-2" @click="sheetContact = true;">Voir les contacts</v-btn>

        </v-list-item-content>
        <v-list-item-content v-else>
          <v-skeleton-loader  type="text" :loading="true" />
      </v-list-item-content>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content >
          <v-list-item-title class="text-capitalize"><v-icon class="mr-3">mdi-information</v-icon>{{ $t("detail.tourist_office") }}</v-list-item-title>
          <v-list-item-content v-if="d.ot !== undefined" :key="keyOffice()">
            <p>{{ d.ot }}</p>
            <v-btn v-if="isOT" text color="teal darken-2" dark @click="closeDialogAndNavToOt()" link >Voir la page</v-btn>
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-skeleton-loader  type="text" :loading="true" />
      </v-list-item-content>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="done">
        <v-list-item-content >
          <v-list-item-title class="text-capitalize"><v-icon class="mr-3">mdi-check</v-icon>{{ $t("detail.validation") }}</v-list-item-title>
          <v-list-item-content >
            Vous avez validé ce point le {{ new Date(getValidation().created).toLocaleDateString() }} à {{ new Date(getValidation().created).toLocaleTimeString() }}
        </v-list-item-content>

        </v-list-item-content>
      </v-list-item>


      <v-list-item v-if="d.source == 'datatourisme'">
        <v-list-item-content >
           <p v-html="$t('detail.datatourisme_origin')"></p>
            <p>{{ $t("detail.updatedAt")}}: {{ d.lastUpdate }}</p>
          </v-list-item-content >
        </v-list-item>
    </v-list>

    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>


  <v-btn text dark color="teal darken-2" v-if="d.geocoord !== undefined" rel="noopener" target="_blank" :href="'https://maps.google.com/maps?q=loc:'+d.geocoord.lat+','+d.geocoord.lng"  >{{ $t("detail.goTo") }}</v-btn>
  <v-btn text v-if="!done" @click="play()" dark color="teal darken-2">{{ $t('detail.play') }}</v-btn>

<Validation  :closeSheet="() => { this.sheet = false; }"  :closeDialog="() => { this.dialog = false; }"  :sheet="sheet" :dialog="dialog" :setValidationOK="setValidationOK" :id="id" :data="d"></Validation>

    </v-card-actions>
    <v-dialog v-model="dialogSuccess" persistent max-width="290">
    <v-card>
      <v-card-title class="headline"><v-icon class="mr-2">mdi-party-popper</v-icon>Félicitations !</v-card-title>
      <v-card-text>Vous avez correctement validé ce point ! Vous remportez {{ d.value || 2 }} points.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="dialogSuccess = false">Non</v-btn>
        <v-btn color="green darken-1" text @click="dialogSuccess = false">Oui</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-bottom-sheet v-model="sheetContact">
    <v-list v-if="d.contact !== undefined">
<v-subheader>Contacts
<v-spacer/><v-btn icon @click="sheetContact = false;"><v-icon>mdi-close</v-icon></v-btn></v-subheader>
<template v-for="(c, index) in d.contact.p">
  <v-list-item  :key="index">
    <v-list-item-avatar>
              <v-avatar size="32px" tile>
                <v-icon>mdi-phone</v-icon>
              </v-avatar>
            </v-list-item-avatar>
   <v-list-item-title :key="'tel_'+index">
     <a target="_blank" rel="noopener"  :href="'tel:'+c">{{ c }}</a>
   </v-list-item-title>
 </v-list-item>

</template>

<template v-for="(c, index) in d.contact.m">
  <v-list-item  :key="'mail_'+index">
    <v-list-item-avatar>
              <v-avatar size="32px" tile>
                <v-icon>mdi-email</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
   <v-list-item-title :key="index">
     <a target="_blank" rel="noopener"  :href="'mailto:'+c">{{ c }}</a>

   </v-list-item-title>
 </v-list-item-content>
 </v-list-item>

</template>
<template v-for="(c, index) in d.contact.w">
  <v-list-item  :key="'web_'+index">
    <v-list-item-avatar>
              <v-avatar size="32px" tile>
                <v-icon>mdi-web</v-icon>
              </v-avatar>
            </v-list-item-avatar>
   <v-list-item-content>
   <v-list-item-title :key="index">
      <a target="_blank" rel="noopener"  :href="c">{{ c }}</a>
   </v-list-item-title>
 </v-list-item-content>
 </v-list-item>

</template>
    </v-list>
</v-bottom-sheet>
  </v-card>
</template>
<script>
import {  GeoFirestore } from 'geofirestore';
import firebase from '@firebase/app';
//const firebase = () =>  import(/* webpackChunkName: "firebase" */'@firebase/app')
//const firebase = () => import(/* webpackChunkName: 'firebase' */ '@firebase/app');

import  '@firebase/firestore';
import Validation from '../validation/wrapper';
export default {
  props: [ 'data', 'id', 'modal', 'slug'],
  components: { Validation },
  data: () => ({
    d: {},
    db: null,
    isOT: false,
    slugOT: '',
    dialog: false,
    sheet: false,
    keyOff: 0,
    sheetContact: false,
    dialogSuccess: false,
    geofirestore: null,
    geocollection: null,
    validationOK: false,
  }),
computed: {
  done: function() {

    if (this.$store.getters.user.data){
      return this.$store.getters.user.data.validations.map(v => v.point).includes(this.id)

    } else {
      return false;
    }
  },
  env() {
    return 'toto';
  }
},
  methods: {
    keyOffice(){
      return 'ot_'+this.keyOff;
    },
    closeDialogAndNavToOt(){
      this.$store.dispatch('closeDialog', {cleanHash: true});
      let slug = this.slugOT;
      this.$router.push({'name':'TouristOfficesDetail', params: { slug }});
    },
    getValidation(){
        return this.$store.getters.user.data.validations.filter(v => v.point == this.id)[0];
    },
    play() {
      if (!this.$store.getters.user.loggedIn) {
        this.sheet = true;
      } else if (!this.done) {
        this.dialog = true;
      }
    },
    setValidationOK: function(){
      this.validationOK = true;
    },
    printLocation: function(){
      let a = this.d.location.address;
      if (a) {
        let a_str = [];
        ['streetAddress', 'zipcode', 'city', 'country'].forEach((x) => {
            if (a[x] !== undefined) {
              a_str.push(a[x]);
            }
        });


        return a_str.join(', ');
      } else {
        return '';
      }

    }
  },
  watch: {
    'd.name_fr':function(v){
      document.title = v +' - Go-France';
    },
    'd.description.fr': function(v){

     if (!document.querySelector('meta[name="description"]')) {
       var link = document.createElement('meta');
       link.setAttribute('name', 'description');
       document.getElementsByTagName('head')[0].appendChild(link);

     }
     if (!document.querySelector('meta[name="og:description"]')) {
       link = document.createElement('meta');
       link.setAttribute('name', 'og:description');
       document.getElementsByTagName('head')[0].appendChild(link);

     }
     let meta_description = document.querySelector('meta[name="description"]');
     let desc = this.d.name_fr + ' à '+this.d.city +' - '+ v;
     meta_description.setAttribute("content", desc);
     let meta_ogdescription = document.querySelector('meta[name="og:description"]');
     meta_ogdescription.setAttribute("content", desc);



    },
    validationOK(v) {
      if (v) {
        this.dialogSuccess = true;
      }
    }
  },
  mounted() {

    const firestore = firebase.firestore();
    this.geofirestore = new GeoFirestore(firestore);
  if (this.data == undefined) {

    this.geocollection = this.geofirestore.collection('pois');
    if (this.id) {
      this.geocollection.doc(this.id).get().then((snapshot) => {
        let data = snapshot.data();
        this.d = data;
        if (this.d == null) {
          alert('Désolé ce point est introuvable.');
          this.$store.dispatch('closeDialog', {cleanHash: true});
        }
        if (this.d.ot) {
          this.slugOT = this.d.ot;
          this.geofirestore.collection('tourist_office').doc(this.d.ot).get().then((doc) => {
            this.d.ot = doc.data().name_fr;
            this.isOT = doc.data().ot;
            this.keyOff = this.keyOff + 1;
            this.$forceUpdate();
          });
        }


      });
    } else {
      this.geocollection.where('slug', '==', this.slug).limit(1).get().then((snapshot) => {
        let data = snapshot.docs[0].data();
        this.d = data;

        if (this.d == null) {
          alert('Désolé ce point est introuvable.');
          this.$store.dispatch('closeDialog', {cleanHash: true});
        }
        if (this.d.ot) {
          this.slugOT = this.d.ot;
          this.geofirestore.collection('tourist_office').doc(this.d.ot).get().then((doc) => {
            this.d.ot = doc.data().name_fr;
            this.isOT = doc.data().ot;
            this.keyOff = this.keyOff + 1;
            this.$forceUpdate();
          });
        }


      }).catch(() => {
      })
    }




  } else {
    if (!Object.keys(this.data).includes('name_fr')){
      this.data = this.data.d;
    }

    this.d = this.data;
    if (this.d.ot) {
      this.geofirestore.collection('tourist_office').doc(this.d.ot).get().then((doc) => {
        this.d.ot = doc.data().name_fr;
      });
    }

  }


}

}
</script>
<style>
.fab_play {
  font-size: smaller;
}
</style>
